import { render, staticRenderFns } from "./EChartsBarDouble.vue?vue&type=template&id=530d7765&"
import script from "./EChartsBarDouble.vue?vue&type=script&lang=js&"
export * from "./EChartsBarDouble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports